<script>
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import RegularLineForm from "@/domains/lines/views/regularLines/partials/RegularLineForm.vue"
  import RegularLineService from "@/domains/lines/services/RegularLineService.js"

  export default {
    components: {
      Breadcrumbs,
      RegularLineForm,
    },
    data() {
      return {
        crumbs: [
          { name: "Início", path: "index" },
          { name: "Linhas", path: "lines.index" },
          { name: "Gestão de Linhas Regulares", path: "lines.regular.index" },
          { name: "Editar Linha Regular", path: "lines.regular.create" },
        ],

        regularLineService: new RegularLineService(),
        lineModel: {
          idlinha: "",
          deitinerario: "",
          destiny_point: null,
          deter_registry: null,
          dtalteracaolinha: "",
          dtfimcontrato: "",
          dtiniciocontrato: "",
          dtiniciolinha: "",
          flsituacao: "",
          fltoalete: "",
          line_schedules: [],
          nuextensao: "",
          nulinharamal: "",
          nupontodestino: "",
          nupontoorigem: "",
          nuservicoveiculo: "",
          nutransportadora: null,
          transportadoraForm: {
            id: null,
            name: "",
          },
          origin_point: null,
          points: [],
          relatable_name: "",
          relatable_render: "",
          sections: [],
          service_vehicle: null,
          patamarizada: "",
          tpatividade: null,
          tpoperacao: "",
          tpoutorga: "",
          tpservcompl: "",
          tpviagem: "",
          vlcoeficientemultiplicacao: "",
          markers: [],
          sectionPoints: [],
        },

        originalLineInfo: {},

        lineFormSuccess: 0,
      }
    },
    mounted() {
      this.fetchLine()
    },
    methods: {
      async fetchLine() {
        try {
          const lineId = this.$route.params.id
          const lineInfo = await this.regularLineService.getRegularLine(lineId)
          if (lineInfo) {
            this.lineModel = lineInfo
            ;(this.lineModel.nutransportadora =
              lineInfo.deter_registry.organization_id),
              (this.lineModel.transportadoraForm = {
                id: lineInfo.deter_registry.organization_id,
                name: lineInfo.deter_registry.organization.business_name,
              })
            this.originalLineInfo = JSON.parse(JSON.stringify(this.lineModel))
          } else {
            this.$router.push({ name: "lines.index" })
          }
        } catch (error) {
          this.$toast.error({
            title: "Erro",
            message: "Erro ao buscar linha",
          })
          this.$router.push({ name: "lines.index" })
        }
      },

      async submitLineForm() {
        try {
          this.regularLineService
            .updateRegularLine(this.lineModel.idlinha, this.lineModel)
            .then(() => {
              this.originalLineInfo = JSON.parse(JSON.stringify(this.lineModel))
              this.lineFormSuccess += 1
              this.$toast.success({
                title: "Sucesso",
                message: "Linha atualizada com sucesso",
              })
              this.fetchLine()
            })
            .catch((error) => {
              this.$toast.error({
                title: "Erro",
                message: error.message,
              })
            })
        } catch (error) {
          this.$toast.error({
            title: "Erro",
            message: "Erro ao atualizar linha",
          })
        }
      },

      discardChanges(keys) {
        keys.forEach((key) => {
          if (this.originalLineInfo[key] != this.lineModel[key]) {
            this.lineModel[key] = this.originalLineInfo[key]
          }
        })
      },
    },
  }
</script>
<template>
  <div class="w-full bg-gray-light">
    <div class="px-2 my-4 sm:px-6">
      <Breadcrumbs class="mb-2" :crumbs="crumbs"/>
      <div
        class="flex flex-wrap justify-between align-baseline border-b-2 border-green-base mb-2"
      >
        <h1 class="text-green-base uppercase pt-5 mb-2">
          Descrição da Linha Regular
        </h1>
      </div>
    </div>

    <div class="mb-6">
      <div class="px-2">
        <div class="px-4">
          <div class="px-4 bg-white shadow-md pt-3 pb-5 text-sm">
            <RegularLineForm
              :line-model="lineModel"
              :sections="lineModel.sections"
              :line-form-success="lineFormSuccess"
              :isEdit="true"
              @submitLineForm="submitLineForm"
              @discardChanges="discardChanges"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
